import React, { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from './firebaseConfig';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;

    const logout = async () => {
      try {
        await signOut(auth);
      } catch (error) {
        console.error('Error logging out:', error);
      } finally {
        if (mounted) {
          navigate('/login', { replace: true });
        }
      }
    };

    logout();

    return () => {
      mounted = false;
    };
  }, [navigate]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
      <Box sx={{ textAlign: 'center' }}>
        <CircularProgress size={28} />
        <Typography sx={{ mt: 2 }} color="text.secondary">
          Signing out...
        </Typography>
      </Box>
    </Box>
  );
};

export default Logout;
